import React from 'react';
import styled from 'styled-components';
import { MultiValueRemoveProps, PlaceholderProps, Theme, components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { FaSearch, FaTimes } from 'react-icons/fa';
import { partial } from 'lodash';

import theme from '../../assets/css/theme';
import LabelItem from '../Forms/LabelItem';
import { getTranslationKey } from '../../modules/utils';
import { Exist } from '../Exist';
import useEmailRecipients, { IEmailItem } from './useEmailRecipients';

const Filter = styled.div`
  margin-bottom: 10px;
  width: 100%;
  min-width: 200px;
  margin-right: auto;

  .react-select__option--is-focused {
    background: #ffffff;
  }

  .react-select__option--is-selected {
    color: ${theme.textColors.baseText};
    background: #ffffff;
  }

  .react-select__multi-value__remove {
    height: 100%;
    cursor: pointer;
    color: ${theme.commonColors.second};
  }

  .react-select__indicator {
    display: none;
  }

  .react-select__menu {
    overflow: hidden;
  }

  .react-select__placeholder {
    color: #c7c7c7;
  }

  .react-select__indicators {
    display: none;
  }
`;
const SearchIcon = styled(FaSearch)`
  margin-right: 5px;
`;
const ErrorWrapper = styled.div`
  color: #ff003a;
  font-size: 12px;
  line-height: 18px;
  margin-top: 5px;
`;

const getSelectTheme = (selectTheme: Theme) => ({
  ...selectTheme,
  borderRadius: 20,
  colors: {
    ...selectTheme.colors,
    primary25: theme.commonColors.second,
    primary: theme.commonColors.second,
    primary50: '#fff'
  }
});

const Placeholder = (props: PlaceholderProps<IEmailItem, true>) => (
  <components.Placeholder {...props}>
    <SearchIcon />
    {getTranslationKey('collectionSettings.sendEmail.recipientsPlaceholder')}
  </components.Placeholder>
);

interface IProps {
  errorText?: string;
}

export const EmailRecipientField: React.FC<IProps> = ({ errorText }) => {
  const {
    emails,
    searchValue,
    openRecipientsState,
    recipientsOptions,
    onSearch,
    onKeyDown,
    onChange,
    onBlur,
    removeEmail
  } = useEmailRecipients();

  const MultiValueRemove = (props: MultiValueRemoveProps<IEmailItem, true>) => (
    <div onClick={partial(removeEmail, props.data.value)} role="button">
      <components.MultiValueRemove {...props}>
        <FaTimes />
      </components.MultiValueRemove>
    </div>
  );

  return (
    <Filter>
      <LabelItem isBold>
        {getTranslationKey('collectionSettings.sendEmail.recipientsLabel')}
      </LabelItem>
      <CreatableSelect
        classNamePrefix="react-select"
        inputValue={searchValue}
        isSearchable
        isMulti
        value={emails}
        onChange={onChange}
        onInputChange={onSearch}
        onKeyDown={onKeyDown}
        options={recipientsOptions}
        components={{ MultiValueRemove, Placeholder }}
        menuIsOpen={openRecipientsState}
        onBlur={onBlur}
        closeMenuOnSelect={false}
        hideSelectedOptions
        theme={getSelectTheme}
      />
      <Exist when={Boolean(errorText)}>
        <ErrorWrapper>{errorText}</ErrorWrapper>
      </Exist>
    </Filter>
  );
};
